export const props = Object.freeze({
  /**
   * Zero-based index of the slide that should be visible. Two-way: emits update-selected-index whenever the active slide changes.
   *
   * @type {Number}
   * @default 0
   * @storybook-control number
   */
  selectedIndex: {
    type: Number,
    default: 0,
  },
});
